<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="40">
            <h2>Documentation Do & Cargo Arrival notice</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <div class id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showVisibility"
              class="md-button-color-toggle md-active"
              @click="showOverflow"
              style
            >
              <span>DOCUMENTATION - RELEASE DELIVERY ORDER</span>

              <md-list-expand>
                <md-list>
                  <div v-if="multiHAWBL.length>0 || NocModel.ffDoId!=''">
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="70"></md-layout>

                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Current Date & Time</label>
                          <b-form-input :formatter="capitalizeAll" disabled v-model="NocModel.currentDate"></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="25">
                        <label v-if="NocModel.ffDoId==''">HBL Number</label>
                        <model-list-select
                          v-if="NocModel.ffDoId==''"
                          option-value="conSeaMultiBlId"
                          option-text="secondBLNumber"
                          :list="HAWBLNoList"
                          placeholder="Select HAWBL No."
                          v-model="NocModel.conSeaMultiBlId"
                        ></model-list-select>
                        <md-layout md-flex="100" v-else>
                          <label>HBL No</label>
                          <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo" v-model="NocModel.hblNo" disabled></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label>Importer Name</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="importerName"
                            name="importerName"
                            v-model="NocModel.importerName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>MBL No</label>
                          <b-form-input :formatter="capitalizeAll" id="mblNo" name="mblNo" v-model="NocModel.mblNo"></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>
                    </md-layout>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <label>Container No./ Seal No.</label>
                        <quill-editor ref="containerSealNo" v-model="NocModel.containerSealNo"></quill-editor>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Documentation Release Delievery Order</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor
                            style="width:100% !important;height:400px !important"
                            v-model="NocModel.nocPreparation"
                          ></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <hr class="hr-border" />

                    <md-layout md-gutter>
                      <md-layout md-flex="40"></md-layout>

                      <md-layout md-flex="20">
                        <md-button
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                          @click="addNocDocumentation"
                          id="addButtonLoaderNoc"
                        >Submit DO Order</md-button>
                        <md-spinner md-indeterminate id="loaderNoc" style="display:none"></md-spinner>
                      </md-layout>

                      <md-layout md-flex="15"></md-layout>
                    </md-layout>
                  </div>

                  <div class="box" v-if="DODocArray.length>0">
                    <div class="box-header">
                      <h3 class="box-title">Do Document Details</h3>
                    </div>

                    <!-- /.box-header -->
                    <div class="box-body">
                      <table id="ffBookingTentative" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Sr No.</th>
                            <th>HAWBL No.</th>
                            <th>Importer Name</th>

                            <th>Print</th>
                            <!--  <th>Delete</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item,index) in DODocArray" :key="index">
                            <td>{{index+1}}</td>
                            <td @click="viewEdit(item)" class="showMoreData">{{item.hblNo }}</td>
                            <td>{{item.importerName }}</td>

                            <md-button
                              class="md-icon-button md-raised md-dense"
                              @click="Print('ConDODoc',item.uploadNocDoc)"
                            >
                              <md-icon>visibility</md-icon>
                            </md-button>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <hr class="hr-s" />
        <div class="phone-viewport" id="railOut">
          <div>
            <md-list>
              <md-list-item id="showvehicleBooking" class="md-button-color-toggle md-active">
                <span>Documentation ­- Cargo Arrival notice</span>

                <md-list-expand>
                  <md-list>
                    <div v-if="HAWBLNoListCargo.length>0 || AuthModel.ffCargoId!=''">
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="70"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Current Date & Time</label>
                            <b-form-input :formatter="capitalizeAll" disabled v-model="AuthModel.currentDate"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Important Notice</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor
                              style="width:100% !important;height:160px !important"
                              v-model="AuthModel.importantNotice"
                            ></quill-editor>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Notice Text</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor
                              style="width:100% !important;height:90px !important"
                              v-model="AuthModel.noticeText"
                            ></quill-editor>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <label v-if="AuthModel.ffCargoId==''">HBL Number</label>
                          <model-list-select
                            v-if="AuthModel.ffCargoId==''"
                            option-value="conSeaMultiBlId"
                            option-text="secondBLNumber"
                            :list="HAWBLNoListCargo"
                            placeholder="Select HAWBL No."
                            v-model="AuthModel.conSeaMultiBlId"
                          ></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label>HBL No</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="hblNo"
                              name="hblNo"
                              v-model="AuthModel.secondBLNumber"
                              disabled
                            ></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Shipper Name</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="mblNo1"
                              name="mblNo1"
                              v-model="AuthModel.exporterName"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>MBL NO</label>
                            <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.mblNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Shipping Line Name</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="importerName"
                              name="importerName"
                              v-model="AuthModel.shippingLineName"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Consigned to.</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="containerSealNo" v-model="AuthModel.consignedTo"></quill-editor>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Vessel/Voyage</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="containerSealNo" v-model="AuthModel.vesselVoyage"></quill-editor>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Container No.</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="containerSealNo" v-model="AuthModel.containerSealNo"></quill-editor>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Origin</label>
                            <b-form-input :formatter="capitalizeAll" id="Origin" name="Origin" v-model="AuthModel.Origin"></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Destination</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="Destination"
                              name="Destination"
                              v-model="AuthModel.Destination"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>CBM</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="Measurement"
                              name="Measurement"
                              v-model="AuthModel.Measurement"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <md-layout md-flex="100">
                            <label>SMTP No.</label>
                            <b-form-input :formatter="capitalizeAll" id="smtpNo" name="smtpNo" v-model="AuthModel.smtpNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>IGM No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="gatewayIgmNo"
                              name="gatewayIgmNo"
                              v-model="AuthModel.gatewayIgmNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label>IGM Date</label>
                          <date-picker
                            lang="en"
                            name="weighingDate"
                            id="weighingDate"
                            type="datetime"
                            format="YYYY-MM-DD hh:mm a"
                            v-model="AuthModel.gatewayIgmDate"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label>Arrival Date</label>
                          <date-picker
                            lang="en"
                            name="weighingDate"
                            id="weighingDate"
                            type="datetime"
                            format="YYYY-MM-DD hh:mm a"
                            v-model="AuthModel.etaToPort"
                          ></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <md-layout md-flex="100">
                            <label>Weight</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="grossWeight"
                              name="grossWeight"
                              v-model="AuthModel.grossWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Local IGM No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="localIgmNo"
                              name="localIgmNo"
                              v-model="AuthModel.localIgmNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label>Local IGM Date.</label>
                          <date-picker
                            lang="en"
                            name="weighingDate"
                            id="weighingDate"
                            type="datetime"
                            format="YYYY-MM-DD hh:mm a"
                            v-model="AuthModel.localIgmDate"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="5"></md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>No of packages</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="containerSealNo" v-model="AuthModel.noOfContainer"></quill-editor>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Actual Consignee</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="consignee" v-model="AuthModel.consignee"></quill-editor>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="30">
                          <md-layout md-flex="100">
                            <label>Commodity</label>
                          </md-layout>
                          <md-layout md-flex="100">
                            <quill-editor ref="commodity" v-model="AuthModel.commodity"></quill-editor>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Remarks</label>
                            <b-form-textarea :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.remarks"></b-form-textarea>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <hr class="hr-border" />
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="30">
                          <h4>Invoice Details :</h4>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Invoice No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="importerName"
                              name="importerName"
                              v-model="AuthModel.invoiceNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Quantity</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="invQuantity"
                              name="invQuantity"
                              v-model="AuthModel.invQuantity"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Description</label>
                            <b-form-textarea :formatter="capitalizeAll"
                              id="invDescription"
                              name="invDescription"
                              v-model="AuthModel.invDescription"
                            ></b-form-textarea>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <hr class="hr-border" />

                      <md-layout md-gutter>
                        <md-layout md-flex="40"></md-layout>

                        <md-layout md-flex="20">
                          <md-button
                            class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                            @click="addAuthDocumentation"
                            id="addButtonLoaderAuth"
                          >Submit Cargo Notice</md-button>

                          <md-spinner md-indeterminate id="loaderAuth" style="display:none"></md-spinner>
                        </md-layout>
                        <md-layout md-flex="15"></md-layout>
                      </md-layout>
                    </div>

                    <div class="box" v-if="CargoDocArray.length>0">
                      <div class="box-header">
                        <h3 class="box-title">Cargo Document Details</h3>
                      </div>

                      <!-- /.box-header -->
                      <div class="box-body">
                        <table id="ffBookingTentative" class="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>HAWBL No.</th>
                              <th>Exporter Name</th>

                              <th>Print</th>
                              <!--  <th>Delete</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,index) in CargoDocArray" :key="index">
                              <td>{{index+1}}</td>
                              <td
                                @click="viewEditCargo(item)"
                                class="showMoreData"
                              >{{item.secondBLNumber }}</td>
                              <td>{{item.exporterName }}</td>

                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="Print('ConCargoArival',item.uploadCargoDoc)"
                              >
                                <md-icon>visibility</md-icon>
                              </md-button>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </md-list>
                </md-list-expand>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
      @close="ProceedSail"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editconSeaImportId") != "" &&
      this.$sessionsStorage.get("editconSeaImportId") != undefined
    ) {
      this.$store.dispatch("setCurrentRoute", "/conSeaImport/ConSeaImpDODoc");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
    // this.vehicle();
  },
  watch: {
    NocModel: {
      handler: function(newVal, oldVal) {
        if (this.NocModel.conSeaMultiBlId != "") {
          let array = this.multiHAWBL.filter(x => {
            return x.conSeaMultiBlId == this.NocModel.conSeaMultiBlId;
          });
          console.log(array);
          if (array.length > 0) {
            this.NocModel.importerName = array[0].importerName;
            this.NocModel.containerSealNo = array[0].houseContainerSealNo;
            this.NocModel.hblNo = array[0].secondBLNumber;
          }
        }
      },
      deep: true
    },

    AuthModel: {
      handler: function(newVal, oldVal) {
        if (this.AuthModel.conSeaMultiBlId != "") {
          let array = this.cargoMultiHAWBL.filter(x => {
            return x.conSeaMultiBlId == this.AuthModel.conSeaMultiBlId;
          });
          console.log(array);
          if (array.length > 0) {
            this.AuthModel.exporterName = array[0].ExporterName;
            this.AuthModel.containerSealNo = array[0].houseContainerSealNo;
            this.AuthModel.secondBLNumber = array[0].secondBLNumber;
            this.AuthModel.Destination = array[0].Destination;
            this.AuthModel.commodity = array[0].houseCommodity;
            this.AuthModel.Measurement = array[0].houseFinalChargeableWeight;

            this.AuthModel.consignedTo =
              "<p>" +
              array[0].importerName +
              ",</p><p>" +
              array[0].importerAddress +
              "</p>";
            this.AuthModel.grossWeight = array[0].houseGrossWeightCargo;
            this.AuthModel.noOfContainer = array[0].houseNoOfPkg;
            // this.AuthModel.vesselNameVoyage = array[0].vesselVoyage;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      NocModel: {
        ffDoId: "",
        conSeaMultiBlId: "",

        nocPreparation: "",
        currentDate: "",
        mblNo: "",
        hblNo: "",
        importerName: "",
        containerSealNo: "",

        uploadNocDoc: "",
        containerInfo: ""
      },
      AuthModel: {
        ffCargoId: "",

        conSeaMultiBlId: "",
        currentDate: "",
        shippingLineName: "",
        consignedTo: "",
        mblNo: "",
        exporterName: "",
        secondBLNumber: "",
        vesselVoyage: "",
        containerSealNo: "",
        Origin: "",
        Destination: "",
        Measurement: "",
        smtpNo: "",
        importantNotice: "",
        noticeText: "",
        gatewayIgmDate: "",
        etaToPort: "",
        grossWeight: "",
        gatewayIgmNo: "",
        localIgmNo: "",
        localIgmDate: "",
        commodity: "",
        remarks: "",
        noOfContainer: "",
        consignee: "",
        invoiceNo: "",
        invQuantity: "",
        invDescription: "",
        uploadCargoDoc: "",
        containerInfo: ""
      },

      sameAuth: {},
      NormalseaImportDataModel: {},

      railOutTableArray: [],
      deleteId: "",
      showVisible: false,

      validate: true,
      validateRail: true,
      toMain: "",
      toMainAuth: "",
      multiHAWBL: [],
      DODocArray: [],
      CargoDocArray: [],
      cargoMultiHAWBL: []
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    quillEditor
  },
  computed: {
    HAWBLNoList() {
      return this.multiHAWBL;
    },
    HAWBLNoListCargo() {
      return this.cargoMultiHAWBL;
    }
  },
  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },

    Print(dir, value) {
      window.open(`${this.docURL}/SeaImport/` + dir + "/" + value);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },

    ProceedSail() {},

    validateFFExport() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    viewEdit(item) {
      Object.keys(this.NocModel).map(x => {
        this.NocModel[x] = item[x];
      });
    },
    viewEditCargo(item) {
      Object.keys(this.AuthModel).map(x => {
        this.AuthModel[x] = item[x];
      });
    },

    showOverflow() {},

    addNocDocumentation() {
      if (this.NocModel.conSeaMultiBlId == "") {
        this.alert.content = "Please Select HBL Number";
        this.$refs["addPop"].open();
        return false;
      }
      this.NocModel["conSeaImportId"] = this.$sessionsStorage.get(
        "editconSeaImportId"
      );

      if (this.validate != false) {
        $("#addButtonLoaderNoc").css("display", "none");
        $("#loaderNoc").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/con_addDODoc.php`,
          data: JSON.stringify(this.NocModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderNoc").css("display", "none");
              $("#addButtonLoaderNoc").css("display", "block");
              if (this.NocModel.ffDoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              this.NocModel.hblNo = "";
              this.NocModel.conSeaMultiBlId = "";
              this.NocModel.ffDoId = "";

              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addAuthDocumentation() {
      if (this.AuthModel.conSeaMultiBlId == "") {
        this.alert.content = "Please Select HBL Number";
        this.$refs["addPop"].open();
        return false;
      }

      this.AuthModel["conSeaImportId"] = this.$sessionsStorage.get(
        "editconSeaImportId"
      );
      //   this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoaderAuth").css("display", "none");
        $("#loaderAuth").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/con_addCargoDoc.php`,
          data: JSON.stringify(this.AuthModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderAuth").css("display", "none");
              $("#addButtonLoaderAuth").css("display", "block");

              if (this.AuthModel.ffCargoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = "";
              });

              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    onClose22() {},

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    getData() {
      let vehicle_drive = {
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId")
      };
      this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/con_fetch_DO_Cargo_Documentation.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);

            Object.keys(data.NormalseaImportData[0]).map(x => {
              this.NormalseaImportDataModel[x] =
                data.NormalseaImportData[0][x] || "";
            });

            if (data.NormalseaImportDataArray.length > 0) {
              this.multiHAWBL = data.NormalseaImportDataArray;
              this.NocModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              this.NocModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.NocModel.currentDate = this.formatDate(new Date());

              if (data.LastPreparationNoc.length > 0) {
                this.NocModel.nocPreparation =
                  data.LastPreparationNoc[0].nocPreparation;
              } else {
                this.NocModel.nocPreparation =
                  "<b><br/><br/><p>To,</p><p>Seabridge Maritime Agencies Pvt. Ltd.</p><p>Kolkata.</p><p>Kind attn: Import Dept.</p></b><br/><p>Dear Sir</p><p>Sub: MBL No: <b><<--From Input MBL->></b></p><p>HBL NO: <b><<--From Input HBL->></b></p><p>Container no: </p><p><<--From Input Container->></p><br/><p>Ref to the above shipment, we are enclosing you the copy of Seaway HBL and MBL copy duly endorsed by us for your reference.</p><p>Also we have no objection to release the container for factory destuffing.</p><br/><b><p>Thanking you,</p><br/><p>For Eagle Maritime pvt Ltd</p><p>Auth. Signatory.</p></b>";
              }
            } else {
              this.multiHAWBL = [];
            }

            if (data.NocDocumentArray.length > 0) {
              this.DODocArray = data.NocDocumentArray;
            } else {
              this.DODocArray = [];
            }

            if (data.CargoBLArray.length > 0) {
              this.cargoMultiHAWBL = data.CargoBLArray;
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.NormalseaImportData[0][x] || "";
              });
              this.AuthModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.AuthModel.currentDate = this.formatDate(new Date());

              if (data.LastAuthLetter.length > 0) {
                this.AuthModel.importantNotice =
                  data.LastAuthLetter[0].importantNotice;
                this.AuthModel.noticeText = data.LastAuthLetter[0].noticeText;
              } else {
                this.AuthModel.importantNotice =
                  "<p>1. THE BELOW SHIPMENT ARRIVERD / EXPECTED AT NHAVA SHEVA ON DATE 20/04/2012.<br/>PLEASE KEEP IN TOUCH WITH US FOR FURTHER INFORMATION AND ARRANGE TO PRESENT ORIGINAL / ENDORESED DOCUMENT AND OBTAIN DELIVERY ORDER AGAINST PAYMENT OF ALL CHARGES THROUGH D.D.</p><p>2 A) PELASE PRODUCE LETTER OF AUTHORITY WHILE APPROCHING US FOR DOCUMENTS AND DO.<br/>  &nbsp;&nbsp;&nbsp;B) FOR PERSONAL EFFECTS PLEASE PRODUCE YOUR PASSPORT AND AUTHORITY LETTER  AT THE TIME OF COLLECTING DELIVERY ORDER. </p><p>3. PAYMENT IS TO BE MADE STRICTY IN DD/ CASH ACCORDING TO OUR FREIGHT INVOICE. </p><p>4 EXCHANGE RATE APPLIED IS SUBJET TO ANY UPWARD REVISION. </p>";

                this.AuthModel.noticeText =
                  "<p>Dear Sir / Madam,</p><br/><p>We have the please in advising you arrivial of the following shipment to you under our consolidation service which are as per details below .</p>";
              }
            } else {
              this.cargoMultiHAWBL = [];
            }

            if (data.AuthDocumentArray.length > 0) {
              this.CargoDocArray = data.AuthDocumentArray;
            } else {
              this.CargoDocArray = [];
            }

            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportExec"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// seaConDOorderDocumentation.vue?220bafe5